type lastMessageLinkTextConfig = {
  name: string
  code: string
  text: string
}
export const LAST_MESSAGE_LINK_LANGUAGES: lastMessageLinkTextConfig[] = [
  {name: 'English', code: 'en-US', text: 'Click Here!'},
  {name: 'Español', code: 'es-US', text: '¡Por favor haz clic aquí!'},
  {name: 'Deutsch', code: 'de-DE', text: 'Bitte hier klicken!'},
  {name: 'Français', code: 'fr-FR', text: 'Veuillez cliquer ici !'},
  {name: 'हिन्दी', code: 'hi-IN', text: 'कृपया यहां क्लिक करें!'},
  {name: 'Português', code: 'pt-BR', text: 'Por favor, clique aqui!'},
  {name: 'العربية', code: 'ar-XA', text: 'يرجى النقر هنا!'},
  {name: 'Bahasa Indonesia', code: 'id-ID', text: 'Silakan klik di sini!'},
  {name: 'Italiano', code: 'it-IT', text: 'Per favore clicca qui!'},
  {name: '日本語', code: 'ja-JP', text: 'ここをクリックしてください！'},
  {name: 'Türkçe', code: 'tr-TR', text: 'Lütfen buraya tıklayın!'},
  {name: 'Tiếng Việt', code: 'vi-VN', text: 'Vui lòng nhấp vào đây!'},
  {name: 'বাংলা', code: 'bn-IN', text: 'অনুগ্রহ করে এখানে ক্লিক করুন!'},
  {name: 'ગુજરાતી', code: 'gu-IN', text: 'કૃપા કરીને અહીં ક્લિક કરો!'},
  {name: 'ಕನ್ನಡ', code: 'kn-IN', text: 'ದಯವಿಟ್ಟು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ!'},
  {name: 'മലയാളം', code: 'ml-IN', text: 'ദയവായി ഇവിടെ ക്ലിക്ക് ചെയ്യൂ!'},
  {name: 'मराठी', code: 'mr-IN', text: 'कृपया येथे क्लिक करा!'},
  {name: 'தமிழ்', code: 'ta-IN', text: 'தயவுசெய்து இங்கே கிளிக் செய்யவும்!'},
  {name: 'తెలుగు', code: 'te-IN', text: 'దయచేసి ఇక్కడ క్లిక్ చేయండి!'},
  {name: 'Nederlands', code: 'nl-NL', text: 'Klik hier alstublieft!'},
  {name: '한국어', code: 'ko-KR', text: '여기를 클릭해주세요!'},
  {name: '官话', code: 'cmn-CN', text: '请点击这里！'},
  {name: 'Polski', code: 'pl-PL', text: 'Proszę kliknij tutaj!'},
  {name: 'Русский', code: 'ru-RU', text: 'Пожалуйста, нажмите здесь!'},
  {name: 'Kiswahili', code: 'sw-KE', text: 'Tafadhali bonyeza hapa!'},
  {name: 'ไทย', code: 'th-TH', text: 'กรุณาคลิกที่นี่!'},
  {name: 'اردو', code: 'ur-IN', text: 'براہ کرم یہاں کلک کریں!'},
  {name: 'Українська', code: 'uk-UA', text: 'Будь ласка, натисніть тут!'},
]
